import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'

export default function GeofenceReportLogic(showOnleyNotSupport=false) {

  const filter_request = ref({
      
    
    owners: [],
    contracts:[],
    types:[],
    categories:[],
    isSupport:null
    

  })

  const errors = ref({})
  const loading = ref(false)
   const devices=ref([])
  let initReq={
    type:'device',
    user: store.state.auth.userData.id
  }
  if(showOnleyNotSupport==true){
    Object.assign(initReq,{isSupport:false})
  }
   ReportService.getDevicesOptions(
    initReq
   ).then(response => {
     
    devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
    })
   .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
   .finally(() =>  loading.value = false)


  const reFilter = () => {
   
        errors.value = {}    
   
    ReportService.getDevicesOptions(
       Object.assign( filter_request.value,{
        type:'device',
        user: store.state.auth.userData.id
    
    })
      ).then(response => {
        
        devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
        // console.log('filterd now',devices.value)
          emit('divicesFilterd', devices.value);
       })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }



  

  return {
    reFilter,
    devices,    
    filter_request,
    errors,
    loading
   
    
      
  }
}
